const getFormattedDateString = (value) => {
    return value.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

export default getFormattedDateString;